import { DEFAULT_RISKDATA_SET, USER_JSON_SET, USER_RISK_DATA_SET, USER_SET, LOGOUT, USER_MSGS_SET } from './actions'

const initialState = {
	messages: [],
	riskData: {},
	riskDataDefault: {
		spread_bitcoin: 'neutral',
		spread_commodities: 'neutral',
		spread_crypto_eur: 'neutral',
		spread_currencies: 'neutral',
		spread_ethereum: 'neutral',
		spread_indices: 'neutral',
		spread_nft: 'neutral',
		spread_stocks: 'neutral',
		spread_usd: 'neutral'
	},
	userData: {},
	userJson: {}
}


export default (state = initialState, action) => {
	switch (action.type) {
	case USER_SET: {
		return {
			...state,
			userData: action.payload
		}
	}
	case LOGOUT: {
		return {
			...initialState
		}
	}
	case USER_JSON_SET: {
		return {
			...state,
			userJson: action.payload
		}
	}
	case USER_MSGS_SET: {
		return {
			...state,
			messages: action.payload
		}
	}
	case DEFAULT_RISKDATA_SET: {
		let riskDataDefault = {...state.riskDataDefault}
		riskDataDefault.brand = action.payload.platform.brandName
		riskDataDefault.endpoint = action.payload.platform.base_url
		let userSpred  = action.payload?.user?.spread
		localStorage.setItem('trading-risk-data', JSON.stringify(userSpred ? userSpred : riskDataDefault))
		return {
			...state,
			riskData: userSpred ? userSpred : riskDataDefault,
			riskDataDefault: riskDataDefault
		}
	}
	case USER_RISK_DATA_SET: {
		localStorage.setItem('trading-risk-data', JSON.stringify(action.payload))
		return {
			...state,
			riskData: action.payload
		}
	}
	default: {
		return state
	}
	}
}
